import React, { useCallback, useEffect, useRef, useState } from "react";
import { Dialog, NavBar, Swiper, Tabs } from 'antd-mobile'

import { 
    BodyView,
    ListView,
    TabsView
} from "../factory/ViewUtil";
import { FutureCellView } from "./TradeCellView";
import { CloseFutureOrder, isLogin, RequestTradeFutures, RequestTradeFuturesProfiting, RequestTradeFuturesUndo } from "../../NetworkFactory";
import { CellStateView } from "../factory/CellViews";
import { AlertContent, DecimalConvert, ToastClear, ToastContent, ToastLoading } from "../factory/FactoryUtil";
import { RefreshAssets } from "../assets/AssetsManager";

const tabItems = [
    { key: '1', title: 'All Delegate' },
    { key: '2', title: 'Order history' }
]

const FuturesOrderViewController = ({goback, navpush}) => {
    const swiperRef = useRef(null)
    const [activeIndex, setActiveIndex] = useState(0)

    const [historyData, setHistoryData] = useState({})
    const [historyType, setHistoryType] = useState('0')
    const [stateCode, setStateCode] = useState(4);
    
    const [stateProfitCode, setStateProfitCode] = useState(4);
    const [profitData, setProfitData] = useState([])
    const [profitCount, setProfitCount] = useState('0.00')

    const updateTab = (index) => {
        setActiveIndex(index)
    }

    // # 历史数据
    const requestHistory = useCallback(() => {
        setStateCode(3)
        RequestTradeFutures().then(response => {
            const data = response.data.data || []
            let mountingData = []
            let closedData = []
            let tradingData = []
            let revokedData = []
            data.forEach((item = {}) => {
                const status = item.status + '' || '-1'
                if(status === '0') {
                    mountingData.push(item)
                }
                else if(status === '1') {
                    closedData.push(item)
                }
                else if(status === '2') {
                    tradingData.push(item)
                }
                else if(status === '3') {
                    revokedData.push(item)
                }
            })
            setHistoryData({
                '0' : mountingData,
                '1' : closedData,
                '2' : tradingData,
                '3' : revokedData,
            })
        }).catch(() => {
            console.log('error');
        })
    }, [])

    // # 正在交易的数据
    const requestProfiting = useCallback(() => {
        RequestTradeFuturesProfiting().then(response => {
            const {data = [], count = '0.00'} = response.data || {}
            setProfitData(data)
            setProfitCount(DecimalConvert(count))
            setStateProfitCode(data.length > 0 ? -1 : 1)
        }).catch(() => {
            setStateProfitCode(1)
        })
    }, [])

    useEffect(() => {
        if(isLogin()) {
            requestProfiting()
            requestHistory()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(Object.keys(historyData).length > 0) {
            setStateCode(historyData[historyType].length > 0 ? -1 : 1)
        }
    }, [historyType, historyData]) // eslint-disable-line react-hooks/exhaustive-deps


    const goRecharge = (limit) => {
        Dialog.confirm({
            content : <div style={{textAlign : 'center', fontWeight : 'bold', fontSize : '17px'}}>
                It's not yet the delivery time, if your Assets amount greater than or equal to {limit} USDT Can be closed in advance of delivery
            </div>,
            cancelText : 'Cancel',
            confirmText : 'Recharge',
            onConfirm: () => {
                navpush('/recharge')
            }
        })
    }
    
    // # 用户平仓
    const onClose = ({id = ''}) => {
        if(id.length === 0) {
            ToastContent('Error')
            return
        }
        ToastLoading('Closing...')
        CloseFutureOrder(id).then(response => {
            ToastClear()
            const {status = -1, offset} = response.data || {}
            if(status === 200) {
                if(offset) {
                    goRecharge(offset)
                } else {
                    requestProfiting()
                    RefreshAssets('2')
                }
            } else if(status === -4) {
                // # 用户无法平仓
                AlertContent('Unable to close order')
            } else if(status === -5) {
                // # 条件不足
                AlertContent('Insufficient closing conditions')
            } else {
                ToastContent('Error')
            }
        }).catch(() => {
            ToastContent('Error')
        })
    }

    // # 撤单
    const onClickType = ({id}, data) => {
        if(historyType === '2') {
            onClose(data)
        } else {
            if(id.length === 0) {
                ToastContent('Error')
                return
            }
            ToastLoading('Undoing...')
            RequestTradeFuturesUndo(id).then(response => {
                ToastClear()
                requestHistory()
                RefreshAssets('2')
            }).catch(()=> {
                ToastContent('Error')
            })
        }
    }

    return(
        <>
            <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>
                    <div style={{
                            display : 'flex',
                            height : '52px',
                            alignItems : 'center',
                            borderLeft : '18px transparent solid',
                            borderRight : '18px transparent solid',
                            boxSizing : 'border-box',
                            fontWeight : 'normal',
                            textAlign : 'center'
                        }}>
                            <div style={{margin : 'auto'}}>
                                <TabsView activeKey={tabItems[activeIndex].key}
                                    onChange={key => {
                                        const index = tabItems.findIndex(item => item.key === key)
                                        updateTab(index)
                                        swiperRef.current?.swipeTo(index)
                                }}>
                                    {tabItems.map(item => (
                                        <Tabs.Tab title={item.title} key={item.key} />
                                    ))}
                                </TabsView>
                            </div>
                    </div>
                </NavBar>
            </div>
            <BodyView content={{style : {'border' : 'none'}}} style={{paddingTop : '52px', paddingBottom : '10px'}}>
                <Swiper direction='horizontal' indicator={() => null}
                    allowTouchMove={false}
                    ref={swiperRef}
                    defaultIndex={activeIndex}
                    onIndexChange={index => {
                        updateTab(index)
                    }}
                    style={{ height : '100%'}}
                    >
                        <Swiper.Item>
                            <div style={{padding : '0 18px'}}>
                                <div style={{
                                    wordBreak : 'break-word', 
                                    fontSize : '14px',
                                    color : 'gray',
                                    margin : '10px 0'
                                }}>
                                    Total position profit and loss: <b style={{color : '#000'}}>{profitCount}</b>
                                </div>
                                <ListView>
                                    <CellStateView stateType={stateProfitCode}/>
                                    {
                                        profitData.map((item, index) => (
                                            <FutureCellView onDo={()=>{onClose(item)}} buttonText='Close' data={item} key={index}/>
                                        ))
                                    }
                                </ListView>
                            </div>
                        </Swiper.Item>
                        <Swiper.Item>
                            <div style={{padding : '0 18px'}}>
                                <TabsView fontSize='13px' stretch={true} 
                                    value={historyType}
                                    onChange={(key)=> {
                                        setHistoryType(key)
                                    }}
                                >
                                    <Tabs.Tab title="Mounting" key={'0'}/>
                                    <Tabs.Tab title="Trading" key={'2'}/>
                                    <Tabs.Tab title="Closed" key={'1'}/>
                                    <Tabs.Tab title="Revoked" key={'3'}/>
                                </TabsView>
                                <div style={{padding : '10px 0'}}>
                                    <ListView>
                                        <CellStateView stateType={stateCode} onRefresh={requestHistory}/>
                                        {
                                            (historyData[historyType] || []).map((item, index) => (
                                                <FutureCellView onDo={()=>{onClickType(item)}} buttonText={historyType === '0' ? 'Undo' : (historyType === '2' ? 'Close' : '')} data={item} key={index}/>
                                            ))
                                        }
                                    </ListView>
                                </div>
                            </div>
                        </Swiper.Item>
                </Swiper>
            </BodyView>
        </>
    );
}
export default React.memo(FuturesOrderViewController)